import { DataService } from './../../../../core/services/data.service';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { faBars, faBell, faCog, faPowerOff, faUser,faGear,faCogs } from '@fortawesome/free-solid-svg-icons';
import { CURRENT_USER_ENDPOINT, LOGINAS_USER, LOGIN_ENDPOINT, VERSION_BAG_ENDPOINT, VEHICLE_FILTER_INCLUDE_CHILDREN, VEHICLE_FILTER_ALSO_DISABLED, VEHICLE_FILTER_ALSO_DATA_HIDDEN, VEHICLE_FILTER_SUBSCRIBED, VEHICLE_FILTER_HAVE_COMMUNICATED, SET_VEHICLE_FILTER_INCLUDE_CHILDREN, SET_VEHICLE_FILTER_ALSO_DISABLED, SET_VEHICLE_FILTER_ALSO_DATA_HIDDEN, SET_VEHICLE_FILTER_HAVE_COMMUNICATED } from 'src/app/core/config/config.constants';
import { environment } from 'src/environments/environment';
import { CurrentUserInfo } from 'src/app/core/models/currentUserInfo';
import { ApiService } from 'src/app/core/services/api.service';
import { VersionBag } from 'src/app/core/models/versionBag';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { WarningModalComponent } from '../../warning-modal/warning-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { AlertingService } from 'src/app/core/services/alerting.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { SelectedCustomerCacheInterface } from 'src/app/core/store/interface/selectedCustomerCache.interface';
import { AppStateInterface } from 'src/app/appState.interface';
import { Store, select } from '@ngrx/store';
import * as PostActions from '../../../../core/store/actions'
import { filter, map, Observable, Subscription } from 'rxjs';
import { getApplySelectedCustomer, getFitlerRefSettingShowStaticCustomerLabel } from 'src/app/core/store/selectors';
import { SelectedPeriodFitler } from 'src/app/core/store/interface/selectedPeriod.interface';
import * as moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ReorderMenuComponent } from 'src/app/shared/customization/reorder-menu/reorder-menu.component';
import { ConfigurationsService } from 'src/app/core/services/configurations.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { User } from 'src/app/core/models/user';
import { RuleEngineCoreService } from 'src/app/core/services/rule-engine-core.service';
import { MqttService } from 'src/app/core/services/mqtt.service';
import { NotificationListenerService, Notification } from 'src/app/core/services/notification-listener.service';
import packageJson from '../../../../../../package.json';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  clientVersion: string;
  packageVersion: string = packageJson.version;
  faBars = faBars;
  faUser = faUser;
  faCog = faCog;
  faBell = faBell;
  faPowerOff = faPowerOff;
  faGear = faGear;
  faCogs = faCogs;
  public versions: VersionBag[];
  public impersonating = false;
  public hasAlerting: boolean;
  public demoMode: boolean;
  public hasRuleEngineAccess: boolean = false;

  // Rule Engine notifications
  public notifications: Notification[] = [];
  public ruleEngineNotificationCount: number = 0;
  public isListeningToRuleEngine: boolean = false;

  public user: User | null = null;
  public alertNotReads: number;
  @Output() navToggled = new EventEmitter<any>();
  @Output() navToggledConf = new EventEmitter<any>();
  @ViewChild('opUser') public opUser: OverlayPanel = null as any;
  @ViewChild('opNotifications') public opNotifications: OverlayPanel = null as any;
  public withShadingOptionsVisible: boolean;
  stylesheetString = 'aft';
  userColor: string; // Colore dinamico per il nome utente
  customLogo: string | null = null; // Custom logo from graphics configuration
  classOpen: any;
  currentUrl: string = '';
  routerSubscription: Subscription;
  // settings: boolean = false;
  customPageConf: boolean;
  hasOrderMenuFeature: boolean = false;

  // Event listener for logo changes
  private logoChangeListener: ((event: CustomEvent) => void) | null = null;

  // Proprietà per il pannello impostazioni
  isSettingsPanelOpen: boolean = false;

   allowedUrls = ['/app/actiaMap']

  cmas: string[] = [
    'fa4d7f05-a54b-4bf0-b24c-243e528f6049', //cma
    'a34318ef-7c14-4589-9786-4d1b729992fb', '1febaa7d-e994-4c08-a1fa-56a2db245e98', '1306c351-4bbd-4c0e-a81d-982e9de7e497', '334e2667-9e05-4267-9dc2-949abc97d6c8', '16276383-52bc-484b-a804-cbc9135dbcef', '0cd131e3-f804-438c-954f-ac99aefa62f0', '4dc11995-6aeb-4b2b-9e2f-16d7db9d622c', '743b15d5-3d87-420a-be71-de17aeb5f1f8', '4922aa6a-6f8e-47c3-8080-b7e60cdad688', '2a135372-6eca-4de6-be6c-8df5a8d46e0a', 'a7f9c16b-c07a-4078-b862-f8885fe858ef', '53f75550-4e1d-45f5-8245-45b8ab09ca93', '8c14c03a-4cc6-4bfc-b987-dd59f0954288', 'fd6c0fd0-eed1-48fa-8850-9f5e193c8b4e', '200c53b1-4487-4464-be7f-3ea418846b8e', '1c34279d-ce92-4472-8686-75f79eac1158', '57aabd88-f3fb-49b4-9fc1-5bf8c4ba75ed', 'f20237d2-500d-406e-bf70-c4124c86b373', 'ed879ae9-26ab-46d3-9674-1e118a1cb12f', 'e6fef854-c1ed-4f56-a75e-5c080deeb82c', '8051f38e-5501-4337-a9d5-0c4ee7676659', '648dc28f-c52a-4d2e-a15d-05449cbf039e', '52f94d22-ee44-4172-bd76-a21ec3bef6fe', 'ab37d605-09da-466c-ac07-aa1d5a734127', '67afa0a7-5a6d-47b0-8bf5-0c996e6f34ca', '9660f90d-6ace-4835-86fd-c3f538257e0f', '95f56b96-3fe2-439b-b0c0-e87435a2d31c', 'f44910a5-cefd-4b5c-8a8b-e60a60fee7f2', '49779325-6a33-4540-906d-f1d3d0025678', 'ebd9c677-d30b-4171-a1a4-603be1e0cd61', 'db325430-8928-4c4a-a318-f199cebf11aa', '268e827e-7d71-45d8-ab14-218356db25d9', 'ab7d5727-f461-458c-8381-49e0f2248444', '87f0d8eb-2ed8-47e1-9faf-68a65ad500b8', 'f0c8c4d5-0d45-4fb0-a500-fbefce99c4c8', 'b4b788c9-5b15-4b4b-a7fa-47ac8bdc4328', '1ef92600-d0be-4024-83f0-eff3fb5bc048'
  ];
  isCmaUser: boolean = false;
  environment = environment.environmentName;

  // Etichetta sola lettura del cliente applicato, mostrata nella stessa posizione del chip
  // filter-ref quando la pagina corrente lo richiede (FilterRefSetting.showStaticCustomerLabel)
  // invece del filtro interattivo completo.
  showStaticCustomerLabel$: Observable<boolean>;
  staticCustomerName$: Observable<string | null>;

  //allowedUrls = ['/app/newTracking', '/app/newTracking/journey','/app/actiaMap']

  constructor(private apiService: ApiService,
    private dataService: DataService,
    private authService: AuthService,
    private dialog: MatDialog,
    public router: Router,
    public alertingService: AlertingService,
    private utilService: UtilsService,
    private store: Store<AppStateInterface>,
    private _configService: ConfigurationsService,
    private _matDialog: MatDialog,
    private logger: LoggerService,
    private mqttService: MqttService,
    public notificationListener: NotificationListenerService,
    private ruleEngineService: RuleEngineCoreService) {
   // this.clientVersion = environment.applicationVersion;
    this.showStaticCustomerLabel$ = this.store.pipe(select(getFitlerRefSettingShowStaticCustomerLabel));
    this.staticCustomerName$ = this.store.pipe(
      select(getApplySelectedCustomer),
      map((c: any) => c?.name ?? null)
    );
    this.routerSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        const navEnd = event as NavigationEnd; // type assertion sicura
        this.currentUrl = navEnd.urlAfterRedirects;
        this.logger.debug('header', `Pagina attuale: ${this.currentUrl}`);
        this.customPageConf = this.authService.isFeatureGranted("customPageConf", "write");
        // Normalizza la url rimuovendo eventuali query/hash e slash finale
        const cleanUrl = this.currentUrl.split(/[?#]/)[0].replace(/\/$/, '');

        // this.settings = this.allowedUrls.some(url =>
        //   cleanUrl === url || cleanUrl.startsWith(url + '/')
        // );

        // if (!this.settings) {
        //   this.navToggledConf.emit();
        // }
        // if (this.currentUrl === '/app/newTracking') {
        //   this.settings = true;
        // } else {
        //   this.settings = false;
        //   this.navToggledConf.emit(true);
        // }
      });
  }

  ngOnInit(): void {
    this.classOpen = this.opUser;
    this.logger.trace('header', 'classOpen ngOnInit', this.classOpen);
    this.withShadingOptionsVisible = false;
    this.hasAlerting = true;
    this.demoMode = false;

    // Load custom logo from localStorage (set by graphics configuration)
    this.loadCustomLogo();

    // Listen for logo change events (when graphics config is saved)
    this.logoChangeListener = ((event: CustomEvent) => {
      this.logger.debug('header', 'Logo change event received', event.detail);
      this.loadCustomLogo();
    }) as EventListener as (event: CustomEvent) => void;

    window.addEventListener('portal-logo-changed', this.logoChangeListener as any);
    this.logger.debug('header', 'Logo change listener registered');

    // Rule Engine notifications
    this.hasRuleEngineAccess = true;

    // Subscribe to notification listener observables
    this.notificationListener.notifications$.subscribe(notifications => {
      this.notifications = notifications;
    });

    this.notificationListener.unreadCount$.subscribe(count => {
      this.ruleEngineNotificationCount = count;
    });

    this.notificationListener.isListening$.subscribe(listening => {
      this.isListeningToRuleEngine = listening;
    });

    // Recupera le informazioni utente già caricate dall'APP_INITIALIZER
    const customerinfo = this.dataService.getCurrentUserInfo();

    // Start listening automatically
    // if (customerinfo?.user?.uidCustomer) {
    //   const tenant = environment.ruleEngine.tenant;
    //   const customerId = customerinfo.user.uidCustomer;
    //   this.notificationListener.startListening(tenant, customerId);
    // }

    if (customerinfo) {
      let customerInfo: SelectedCustomerCacheInterface = {
        isVirtual: false,
        isFieldTest: false,
        isSubscriptionEnded: false,
        subscriptionEndDate: null,
        vatCode: null,
        fiscalCode: null,
        contactName: null,
        contactPhone1: null,
        contactPhone2: null,
        contactEmail: null,
        contactAddress: null,
        logo: null,
        uidCountry: '',
        uidLegalRule: '',
        groups: [],
        features: [],
        children: [],
        isTachoLight: false,
        maxVehicles: null,
        name: customerinfo.customer.name,
        uidParent: customerinfo.customer.uidParent,
        isHardLocked: customerinfo.customer.isHardLocked,
        uid: customerinfo.customer.uid,
        nameWithChildren: '',
        timezone: customerinfo.customer.timezone
      };
      this.user = customerinfo.user;
      this.isCmaUser = this.cmas.includes(customerinfo.customer.uid);
      this.impersonating = customerinfo.impersonatingOtherUser;
      this.hasOrderMenuFeature = this.user!.group.features.find(f => f.name === 'administration')
        ?.functionalities.find(func => func.name === 'orderMenu')?.settings.enabled || false;
    } else {
      // Fallback: se i dati non sono stati caricati dall'initializer, ricaricali
      this.checkCurrent();
    }

    this.getVersion();
    this.stylesheetString = this.utilService.getStylesheetString();
    this.userColor = this.utilService.getMainColor();
  }

  /**
   * Load custom logo from localStorage (if set via graphics configuration)
   * This allows dynamic logo override without breaking the CSS fallback flow
   */
  private loadCustomLogo(): void {
    const savedLogo = localStorage.getItem('actia-portal-logo');
    if (savedLogo) {
      this.customLogo = savedLogo;
      this.logger.debug('header', 'Custom logo loaded from localStorage');
    } else {
      this.customLogo = null;
      this.logger.debug('header', 'No custom logo found, using CSS default');
    }
  }

  /**
   * Public method to refresh the custom logo
   * Can be called when graphics configuration is updated during the session
   */
  public refreshCustomLogo(): void {
    this.loadCustomLogo();
  }

  openTogle($event) {
    this.classOpen = this.opUser.overlayVisible;
    this.logger.trace('header', 'classOpen openTogle', this.classOpen);
    this.opUser.toggle($event)
    setTimeout(() => {
      let element = document.querySelector('.p-overlaypanel') as HTMLElement;
      if (element) {
        if (!this.classOpen) {
          element.style.position = 'fixed';
          element.style.top = '35px'
        } else {
          element.style.position = 'absolute';
        }
      }
    }, 100);
  }


  toggleWithShadingOptions() {
    this.withShadingOptionsVisible = !this.withShadingOptionsVisible;
  }

  toggleNav() {
    this.navToggled.emit();
  }

  toggleNavConf() {
    this.navToggledConf.emit();
  }

  confirmLogout() {
    this._configService.resetUserInfo.next();
    this.store.dispatch(PostActions.logout());

    this.router.navigate(['/auth/login'])
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  confirmLogoutImpersonatedUser() {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '500px',
      data: "global.confirmEndEmulatingUser",
      position: { top: '40px' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        let { token } = await <any>this.apiService.delete(LOGINAS_USER).toPromise();
        localStorage.clear();
        localStorage.setItem("token", token);
        // Ritorno all'utente reale: bootstrap completo verso la root /#/app (stesso approccio di
        // login-as.useLoginAsToken). L'APP_INITIALIZER ricarica utente + dashboard e la
        // DynamicHomeGuard redirige alla homepage corretta dell'utente reale.
        // NB: hash routing → target "/#/app" (non "/app", che darebbe 404 sull'host statico);
        // il reload() esplicito è necessario perché il solo cambio di hash non ricarica la pagina.
        window.location.href = "/#/app";
        window.location.reload();
      }
    });
  }

  //  getCurrent() {
  //   let current: any = this.dataService.getCurrentUserInfo();
  //   if (current) {
  //     this.user = current.user;
  //     this.impersonating = current.impersonatingOtherUser;
  //     console.log(current, "getCurrent");
  //   } else {
  //     localStorage.clear();
  //     this.router.navigate(['/auth/login']);
  //   }
  // }

  checkCurrent() {
    this.apiService.get(CURRENT_USER_ENDPOINT)
      .subscribe(
        (currentUserInfo: any) => {
          currentUserInfo = currentUserInfo as CurrentUserInfo;
          this.user = currentUserInfo.user;
          this.dataService.setCurrentUserInfo(currentUserInfo);
          this.impersonating = this.dataService.getCurrentUserInfo().impersonatingOtherUser;

          this.alertingService.alertingConnect();
        },
        error => {
          let e = error as HttpErrorResponse;

          if (e.status == 401) {
            localStorage.clear();
            this.router.navigate(['/auth/login']);
          }
          this.dialog.open(WarningModalComponent, {
            width: '500px',
            data: e.status + e.statusText,
            position: { top: '40px' }
          });

        });
  }

  getVersion() {
    this.apiService.get(VERSION_BAG_ENDPOINT)
      .subscribe(
        (versions: any) => {
          versions = versions as VersionBag[];
          this.versions = versions;
        },
        error => {

        });
  }
  toogleMenu() {
    this.opUser.toggle(event);
  }

  onSettingsClick() {
    this.logger.debug('header', 'Icona impostazioni cliccata');
    this.isSettingsPanelOpen = !this.isSettingsPanelOpen;
  }

  onCloseSettingsPanel() {
    this.isSettingsPanelOpen = false;
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe(); // evita memory leak

    // Remove logo change listener
    if (this.logoChangeListener) {
      window.removeEventListener('portal-logo-changed', this.logoChangeListener as any);
      this.logger.debug('header', 'Logo change listener removed');
    }


    // Cleanup notification listener
    this.notificationListener.stopListening();

    this.user = null;
  }

  // ============================================================
  // Rule Engine Notification Methods
  // ============================================================

  /**
   * Toggle notification listener
   */
  toggleRuleEngineNotifications() {
    const tenant = environment.ruleEngine.tenant;
    const currentUser = this.dataService.getCurrentUserInfo();
    const customerId = currentUser?.user?.uidCustomer;

    if (!customerId) {
      console.warn('[Header] Cannot toggle notifications: customerId not available');
      return;
    }

    this.notificationListener.toggleListening(tenant, customerId);
  }

  /**
   * Mark notification as read
   */
  markNotificationAsRead(notificationId: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.notificationListener.markAsRead(notificationId);
  }

  /**
   * Mark all notifications as read
   */
  markAllNotificationsAsRead() {
    this.notificationListener.markAllAsRead();
  }

  /**
   * Clear all notifications
   */
  clearAllNotifications() {
    this.notificationListener.clearNotifications();
  }

  /**
   * Get notification CSS class based on type/severity
   */
  getNotificationClass(notification: Notification): string {
    if (notification.type === 'down') {
      return 'notification-success'; // Green for recovery
    }

    switch (notification.severity) {
      case 'critical':
        return 'notification-critical'; // Red
      case 'warning':
        return 'notification-warning';  // Yellow
      default:
        return 'notification-info';     // Blue
    }
  }

  /**
   * Get notification icon based on type/severity
   */
  getNotificationIcon(notification: Notification): string {
    if (notification.type === 'down') {
      return 'pi pi-check-circle'; // Recovery icon
    }

    switch (notification.severity) {
      case 'critical':
        return 'pi pi-times-circle'; // Error
      case 'warning':
        return 'pi pi-exclamation-triangle'; // Warning
      default:
        return 'pi pi-info-circle'; // Info
    }
  }

  openCustomizeSidenavModal() {
    const modalRef = this._matDialog.open(ReorderMenuComponent, {});
  }

  goToHome() {
    const url = this._configService.homePageDashboard ? '/app/dashboards/dashboard/' + this._configService.homePageDashboard.id : '/app/home';
    this.router.navigate([url]);
  }
}
